import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.section-our-industries-block__button')) {
        const block = document.querySelector('.section-our-industries-block');
        const buttonsDesktop = block.querySelectorAll('.js-section-our-industries-block-button-desktop');
        const buttonsMobile = block.querySelectorAll('.js-section-our-industries-block-button-mobile');
        const contents = block.querySelectorAll('.section-our-industries-block__tab-content');
        const arrowRight = block.querySelector('.section-our-industries-block__arrow-right');
        const arrowLeft = block.querySelector('.section-our-industries-block__arrow-left');

        let currentIndexDesktop = 0;
        let currentIndexMobile = 0;

        new Swiper(document.querySelector('.js-section-our-industries-block-buttons-wrapper'), {
            slidesPerView: 'auto',
            spaceBetween: 30,
            freeMode: true,
            grabCursor: true,
        });

        function updateTabsDesktop(index) {
            // Ensure the index is within bounds
            if (index < 0) {
                currentIndexDesktop = buttonsDesktop.length - 1;
            } else if (index >= buttonsDesktop.length) {
                currentIndexDesktop = 0;
            } else {
                currentIndexDesktop = index;
            }

            // Deactivate all buttons
            buttonsDesktop.forEach(btn => btn.classList.remove('is-active'));
            // Hide all tab contents within the block
            contents.forEach(content => content.classList.remove('is-visible'));

            // Activate the button at the new index
            buttonsDesktop[currentIndexDesktop].classList.add('is-active');
            // Show the corresponding tab content within the block
            const tabId = buttonsDesktop[currentIndexDesktop].getAttribute('data-tab');
            const tabContent = block.querySelector(`#${tabId}`);
            if (tabContent) {
                tabContent.classList.add('is-visible');
            }
        }
        function updateTabsMobile(index) {
            // Ensure the index is within bounds
            if (index < 0) {
                currentIndexMobile = buttonsMobile.length - 1;
            } else if (index >= buttonsMobile.length) {
                currentIndexMobile = 0;
            } else {
                currentIndexMobile = index;
            }

            // Deactivate all buttons
            buttonsMobile.forEach(btn => btn.classList.remove('is-active'));
            // Hide all tab contents within the block
            contents.forEach(content => content.classList.remove('is-visible'));

            // Activate the button at the new index
            buttonsMobile[currentIndexMobile].classList.add('is-active');
            // Show the corresponding tab content within the block
            const tabId = buttonsMobile[currentIndexMobile].getAttribute('data-tab');
            const tabContent = block.querySelector(`#${tabId}`);
            if (tabContent) {
                tabContent.classList.add('is-visible');
            }
        }

        buttonsDesktop.forEach((button, index) => {

            button.addEventListener('click', () => {
                updateTabsDesktop(index);
            });
        });
        buttonsMobile.forEach((button, index) => {

            button.addEventListener('click', () => {
                updateTabsMobile(index);
            });
        });

        if (arrowRight) {
            arrowRight.addEventListener('click', () => {
                updateTabsDesktop(currentIndexDesktop + 1);
            });
        }

        if (arrowLeft) {
            arrowLeft.addEventListener('click', () => {
                updateTabsDesktop(currentIndexDesktop - 1);
            });
        }
    }
});
